import { localizeSystemText } from '../../i18n/messages';
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { getMatchReasons } from '../common/Validations';
import { useTranslation } from 'react-i18next';

const ClientDuplicateModal = ({ show, duplicates, onConfirm, onMerge, onClose }) => {
  const { t: tr } = useTranslation();
  if (!show) return null;

  const handleMerge = (duplicate, e) => {
    e.preventDefault();
    if (onMerge) {
      onMerge(duplicate);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton closeLabel={tr("common:close")}>
        <Modal.Title>{tr("manage:warningPossibleDuplicatesFound_103")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{tr("manage:found_104")} {duplicates.length} {tr("manage:potential_105")}{duplicates.length === 1 ? tr("manage:extraDuplicate_16") : tr("manage:extraDuplicates_17")}:
        </p>
        <ul>
          {duplicates.map((duplicate) => {
            const reasons = getMatchReasons(duplicate);
            const reasonsText = reasons.map(reason => localizeSystemText(reason, tr)).join(', ');

            return (
              <li key={duplicate.id}>
                <strong>{duplicate.firstName} {duplicate.lastName}</strong>
                <span className="badge badge-secondary ml-2">{tr(duplicate.archived ? 'manage:mergeStudents.archivedClient' : 'manage:mergeStudents.activeClient')}</span>
                {` (ID: ${duplicate.id})`}
                {reasonsText && tr("common:matchReasons", { reasons: reasonsText })}
                {onMerge && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary ms-2"
                    onClick={(e) => handleMerge(duplicate, e)}
                  >{tr("common:merge")}</button>
                )}
              </li>
            );
          })}
        </ul>
        <p className="mb-0">{tr("manage:areYouSureYouWantToSaveTheClient_106")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>{tr("common:cancel")}</Button>
        <Button variant="warning" onClick={onConfirm}>{tr("manage:yesSaveAnyway_107")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

ClientDuplicateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  duplicates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      matchReasons: PropTypes.arrayOf(PropTypes.string),
      matchReason: PropTypes.string, // Legacy format support
    })
  ).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onMerge: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

ClientDuplicateModal.defaultProps = {
  onMerge: null,
};

export default ClientDuplicateModal;
